import type { ComponentType, MouseEvent } from 'react';

type Props = {
  /** The node's name, read out as "Collapse <label>". */
  label: string;
  icon: ComponentType<{ className?: string }>;
  onCollapse: () => void;
};

/** The only way to collapse a node: a click on the card itself always expands. */
export function CollapseButton({ label, icon: Icon, onCollapse }: Props) {
  return (
    <button
      type="button"
      aria-label={`Collapse ${label}`}
      title="Collapse"
      className="nodrag -m-1 shrink-0 rounded p-1 text-gray-400 hover:bg-zinc-100 hover:text-gray-700 dark:text-zinc-500 dark:hover:bg-zinc-700 dark:hover:text-zinc-200"
      onClick={(event: MouseEvent) => {
        // The card's click handler would select the node again.
        event.stopPropagation();
        onCollapse();
      }}
    >
      <Icon className="size-3.5" />
    </button>
  );
}
